import Timer from '../../../assets/timer.svg';

const TimerIcon = (props: React.SVGProps<SVGSVGElement> & { color: string }): JSX.Element => {
  return <Timer fill={props.color} {...props} />;
};

export default TimerIcon;
